<template>
    <div :class="generateClass" >
      <fg-input
        :label="config.label"
        :data-cy="config.cyData"
        :placeholder="config.placeholder"
        v-model="form[config.fieldName]"
        :readonly="readonly"
        :name="config.fieldName"
        v-validate.initial="config.validationRule"
        :error="getError(config.fieldName)"
        :data-vv-as="config.label"
        :is-text-area="true"
        :rows=2
        :errorsMsg=getErrorMas(config.fieldName)
      ></fg-input>
    </div>
</template>
<script>
  import {generateClass} from  '../../../../mixins/baseComponets/generateClass'
  import {validateExt} from '../../../../mixins/baseComponets/validateExt'
    export default {
        name: 'BaseTextArea',
        props: {
          config: { type: Object, required: true},
          form: { type: Object }
        },
        mixins: [generateClass, validateExt]
    }
</script>
